import { TFunction } from 'i18next';
import { DocumentationRenewalRepetitionEnum } from 'graphql-common';

export default function getRenewalRepetitionOptions(
  t: TFunction<'translation', undefined>,
) {
  return [
    {
      value: DocumentationRenewalRepetitionEnum.Monthly,
      label: t('repeat-monthly'),
    },
    {
      value: DocumentationRenewalRepetitionEnum.Quarterly,
      label: t('repeat-quarterly'),
    },
    {
      value: DocumentationRenewalRepetitionEnum.HalfYearly,
      label: t('repeat-half-yearly'),
    },
    {
      value: DocumentationRenewalRepetitionEnum.Yearly,
      label: t('repeat-yearly'),
    },
    {
      value: DocumentationRenewalRepetitionEnum.Custom,
      label: t('custom'),
    },
  ];
}
